var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.fullLoading)?_c('div',{attrs:{"id":"loader-wrapper"}},[_c('i',{staticClass:"el-icon-loading"})]):_vm._e(),(_vm.isConstruct)?[_c('router-view')]:[_c('Header'),_c('div',{staticClass:"main",style:({
      height: _vm.mainHeight,
    }),attrs:{"id":"main"}},[_c('router-view'),_c('Footer')],1)],_c('el-backtop',{staticClass:"toTop",attrs:{"target":"#app"}},[_c('img',{attrs:{"src":require("@/assets/toTop.png")}})])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }